export default __webpack_public_path__ + "images/sidebar-4.jpg";